import { render } from "./InspectionPlanDetail.vue?vue&type=template&id=7068ff20"
import script from "./InspectionPlanDetail.vue?vue&type=script&lang=js"
export * from "./InspectionPlanDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__